export default {
  // 新增消息模板
  add: 'backend.odc.notify.template.add',

  // 分页获取消息模板
  list: 'backend.odc.notify.template.page.list',

  // 编辑消息模板
  edit: 'backend.odc.notify.template.edit',

  // 删除消息模板
  delete: 'backend.odc.notify.template.delete',

  // 发送消息
  send: 'backend.odc.notify.instantiation.add',

  // 获取消息列表
  sendList: 'backend.odc.notify.instantiation.page.list',

  // 消息的回复
  reply: 'backend.odc.notify.instantiation.reply',

  // 获取消息详情
  details: 'backend.odc.notify.instantiation.get',

  // 删除消息，所有人将不再可见
  templateDelete: 'backend.odc.notify.instantiation.delete'
}
